export class OrganizationUpdateModel {
  name!: string;
  shopifyHostDomain!: string;
  version!: number;
}
